module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_cyberknife-480efe03752cfb85ce5bee3f6317d86e.png";